import { CardType, DebitAccount } from '@generated-types';
import { cardTypeDel, cardTypeGet } from '@utils/query-utils';

import { REST_BASE_URL } from '../common';

export const getDebitAccount = async (accountId: string) =>
    cardTypeGet(CardType.DEBIT)<DebitAccount>(`${REST_BASE_URL}/debit-accounts/${accountId}`);

export interface CloseCreditAccountRequest {
    accountToClose: string;
    reason: string | null;
    accountToReceive?: string;
}

const closeCreditAccountRequest = async ({ accountToClose, reason, accountToReceive }: CloseCreditAccountRequest) =>
    cardTypeDel(CardType.CREDIT)(
        `${REST_BASE_URL}/billing-accounts/${accountToClose}`,
        new URLSearchParams([
            ['reservedAccount', `${accountToReceive}`],
            ['reason', `${reason}`],
        ]),
    );

export const closeCreditAccount = async (requestData: CloseCreditAccountRequest) =>
    closeCreditAccountRequest(requestData);

export const getDebitAccounts = async () =>
    cardTypeGet(CardType.DEBIT)<DebitAccount[]>(`${REST_BASE_URL}/debit-accounts`);
